<template>
  <login-form />
</template>

<script lang="ts">
import LoginForm from '@web/components/LoginForm.vue'

export default {
  name: 'Login',
  components: {
    LoginForm
  }
}
</script>
